var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "workbench-editor" },
    [
      _c("Toolbar", {
        staticClass: "editor-toolbar",
        attrs: {
          editor: _vm.editor,
          defaultConfig: _vm.toolbarConfig,
          mode: "default",
        },
      }),
      _c("Editor", {
        staticClass: "editor-body",
        attrs: {
          value: _vm.value,
          defaultConfig: _vm.editorConfig,
          mode: "default",
        },
        on: {
          onCreated: _vm.createdEditor,
          onChange: _vm.changedEditor,
          customPaste: _vm.customPaste,
        },
      }),
      _c(
        "div",
        { staticClass: "editor-hint" },
        [
          _vm._v(
            _vm._s(
              _vm.uploading
                ? "文件上传中，请稍候…"
                : "正文最多15000字；图片10MB内，MP4视频单文件20GB内；正文和附件合计最多20个文件。"
            )
          ),
          _vm.uploading
            ? _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.cancelUploads },
                },
                [_vm._v("取消上传")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }